












// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import EditBasePiscine from '@/components/administration/piscine/edit/EditBasePiscine.vue'
import * as rules from '@/utils/validationRules'
import { toNumberDictionary, toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { AloPiscine } from '@/models/alo/AloPiscine'
import { AloForfait } from '@/models/alo/AloForfait'

@Component({
  name: 'EditTarif',    
  components:{EditBasePiscine}
})
export default class EditTarif extends Vue {
      
  private piscine:AloPiscine = getDefaultAloPiscine()  

  edit(item:AloPiscine) {    
    this.piscine = (this.$refs.baseEdit as EditBasePiscine).edit(item)     
  }


  get configuration(){
    return this.$store.myGetters.configuration
  }

  get forfaitList(){
    return this.$store.myGetters.forfaitList
  }
  
 
 
}
